import { errorConfirm } from "../basket-v2/errorReporting";

export function showConflictingBasketPopup(): Promise<boolean> {
  return errorConfirm(
    `<p>You have tickets for another event in your basket, you can only have one event in your basket at a time.</p>
    <p>If you continue, your basket will be deleted. Do you want to continue?</p>`
  );
}
